import { computed, defineComponent, onBeforeUnmount, ref, watch } from "vue";
import html_iway from "./template.iway.html?raw";

const app_theme = import.meta.env.VITE_APP_THEME;
let html = "";
if ("iway" == app_theme) {
  html = html_iway;
} else if ("lic" == app_theme) {
  html = html_iway;
} else if ("sak" == app_theme) {
  html = html_iway;
}

interface Props {
  value: number;
  min: number;
  max: number;
  debounce: number;
}

export default defineComponent({
  template: html,
  props: {
    value: {
      type: Number,
      required: true,
    },
    min: {
      type: Number,
      default: 0,
    },
    max: {
      type: Number,
      required: true,
    },
    debounce: {
      type: Number,
      default: 300,
    },
  },
  emits: {
    change: (value: number) => typeof value === "number",
  },
  setup(props: Props, { emit }) {
    const localValue = ref(props.value);
    let timer: ReturnType<typeof setTimeout> | null = null;

    watch(() => props.value, (newValue) => {
      localValue.value = newValue;
    });

    const emitChange = () => {
      if (timer) {
        clearTimeout(timer);
      }
      timer = setTimeout(() => {
        emit("change", localValue.value);
      }, props.debounce);
    };

    const isDecrementDisabled = computed(() => localValue.value <= props.min);
    const isIncrementDisabled = computed(() => localValue.value >= props.max);

    const decrement = () => {
      if (isDecrementDisabled.value) {
        return;
      }
      localValue.value--;
      emitChange();
    };

    const increment = () => {
      if (isIncrementDisabled.value) {
        return;
      }
      localValue.value++;
      emitChange();
    };

    onBeforeUnmount(() => {
      if (timer) {
        clearTimeout(timer);
      }
    });

    return {
      localValue,
      isDecrementDisabled,
      isIncrementDisabled,
      decrement,
      increment,
    };
  },
});
